module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-pl-PL.e8eaf239.jpg";